import Vue from "vue";
import Cookies from "js-cookie";
import router from "@/router";
import authService from "@/services/authService";

const state = () => ({
  logged: false,
  userData: {},
  token: null,
});

const mutations = {
  setLogin(state, status) {
    state.logged = status;
  },
  setToken(state, token) {
    state.token = token; // Actualiza la variable de estado con el token recibido
    Cookies.set("token", token, {
      secure: true,
      sameSite: "Strict",
      expires: 7,
    }); // Guarda el token en una cookie segura
  },
  clearToken(state) {
    state.token = null;
    Cookies.remove("token");
  },
  setUserData(state, payload) {
    state.userData = payload;
    localStorage.setItem("userData", JSON.stringify(payload));
  },
};

const actions = {
  async login({ commit }, payload) {
    try {
      // Si es login con Google, usar el servicio correspondiente
      if (payload.loginGoogle) {
        // Aquí se implementaría la lógica de login con Google
        // Por ahora, lanzamos un error indicando que no está implementado
        throw new Error("Login con Google no implementado en esta versión");
      } else {
        // Login normal con usuario y contraseña usando el servicio de autenticación
        const response = await authService.login(payload.username, payload.password);
        
        // Establece el token y los datos del usuario
        commit("setToken", response.token);
        commit("setUserData", response.user);
        commit("setLogin", true);

        // Redirige a la ruta raíz si no está ya allí
        if (router.currentRoute.name !== "home") {
          router.push({ name: "home" });
        }
      }
    } catch (error) {
      console.error("Error en login:", error);
      Vue.prototype.$toast.open({
        message: error.message || "Error en el login. Verifique sus credenciales.",
        position: "top-right",
        type: "error",
        duration: 3000,
      });

      throw error;
    }
  },

  checkLogin({ commit }) {
    // Verificar si hay un token en las cookies
    const token = Cookies.get("token");
    
    // Si hay token, verificar si está autenticado usando el servicio
    if (token) {
      commit("setLogin", authService.isAuthenticated());
      const userData = authService.getUserData();
      if (userData) {
        commit("setUserData", userData);
      }
    } else {
      commit("setLogin", false);
    }
  },

  logout({ commit }) {
    // Usar el servicio de autenticación para hacer logout
    authService.logout();
    
    // Actualizar el estado
    commit("clearToken");
    commit("setUserData", {});
    commit("setLogin", false);
    
    // Redirigir al login solo si no estamos ya en la página de login
    if (router.currentRoute.name !== "login") {
      router.push({ name: "login" }).catch(err => {
        // Ignorar errores de navegación redundante
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    }
  },
};

const getters = {
  isAuthenticated: (state) => state.logged,
  getUserData: (state) => state.userData,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
